// import lib
import { lazy } from "react";

const routes = [
  {
    exact: true,
    path: "/forgot_password",
    element: lazy(() => import("../pages/ForgotPassword")),
  },
];

export default routes;
